module.exports = __webpack_public_path__ + "img/icon295.077e9263.png";